import React from 'react';
import { Button } from 'omni-common-ui';
import PropTypes from 'prop-types';

const ViewNavButton = ({ title, isPrimary, disabled, onClick, linkHref, newTab, className }) =>
  <Button autoWidth
      type={isPrimary ? Button.Type.primary : Button.Type.default}
      disabled={disabled}
      onClick={onClick}
      newTab={newTab}
      className={className}
      linkHref={linkHref}>
    {title}
  </Button>;

ViewNavButton.propTypes = {
  title: PropTypes.string,
  isPrimary: PropTypes.bool,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  linkHref: PropTypes.string,
  newTab: PropTypes.bool,
  className: PropTypes.string,
};

export default ViewNavButton;



// WEBPACK FOOTER //
// ./containers/Group/MidtermAndFinalExamHFv4/ViewNavHFv4/ViewNavButton/index.jsx